import { render, staticRenderFns } from "./BlacklistNumbers.vue?vue&type=template&id=617a60ed"
import script from "./BlacklistNumbers.vue?vue&type=script&lang=js"
export * from "./BlacklistNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports